import styled from 'styled-components';
import { getColor, type Theme } from 'styles/theme';
import { arrowUp } from 'styles/icons';
import { breakpoint } from 'styles/globals';

export const ScrollUpButton = styled.button<{ theme: Theme; $isRecommends: boolean }>`
  background-color: ${getColor('accentPrimary')};
  opacity: 50%;
  width: 40px;
  height: 40px;
  position: sticky;
  bottom: ${({ $isRecommends }) => ($isRecommends ? '90px' : '16px')};
  margin-left: auto;
  float: right;
  visibility: ${({ $isRecommends }) => ($isRecommends ? 'hidden' : 'visible')};
  
  
  &::after {
    ${arrowUp}
    border-color: ${getColor('neutralWhite')};
    border-width: 0 2.5px 2.5px 0;
  }
    
  &:hover {
    opacity: 100%;
  }
  
  @media (${breakpoint.mdMin}) {
    visibility: visible;
  }
`;
